let isSwiperActive = false;
const freeStepsClaimed = new Set();

class SideCart extends HTMLElement {
    constructor() {
        super();

        this.buttonsQty = this.querySelectorAll('.sidecart__qty-btn');
        this.inputsQty = this.querySelectorAll(' .sidecart__input');
        this.inputsValue = this.querySelectorAll('.sidecart__input-value');
        this.loader = document.querySelector('.sidecart__loader');
        this.toggleOpenCartButtons = document.querySelectorAll('.close-sidecart');
        this.toggleOpenCartsButtons = document.querySelectorAll('[data-open-cart]');

        if (window.location.href.includes('open-cart=true')) {
            this.openCart();
            window.history.pushState({}, document.title, window.location.pathname);
        }
        this.init();
    }

    connectedCallback() {
        this._qtyDebounceTimers = {};

        const handleButtonClick = (button, ispp = false) => {
            const action = button.getAttribute('data-input-action');
            const input = button
                .closest(ispp ? '.sidecart-block-item__content' : '.sidecart__inputs')
                .querySelector('.sidecart__input');
            const value = parseInt(input.value);
            const variant_id = button.closest('[data-current-key]').dataset.currentKey;

            if (action === 'increase') {
                const container = button.closest('[data-current-key]');
                const policy = container.dataset.inventoryPolicy;
                const maxQty = parseInt(container.dataset.inventoryQuantity);
                if (policy === 'deny' && !isNaN(maxQty) && value >= maxQty) {
                    this.showStockToast();
                    return;
                }
            }

            const newValue = action === 'increase' ? value + 1 : value > 0 ? value - 1 : 0;
            input.value = newValue;

            const valueDisplay = button.closest('[data-current-key]').querySelector('.sidecart__input-value');
            if (valueDisplay) valueDisplay.textContent = newValue;

            if (this._qtyDebounceTimers[variant_id]) {
                clearTimeout(this._qtyDebounceTimers[variant_id]);
            }

            this._qtyDebounceTimers[variant_id] = setTimeout(() => {
                delete this._qtyDebounceTimers[variant_id];
                this.showLoader();
                this.updateQty(variant_id, newValue);
            }, 300);
        };

        this.querySelectorAll('[data-delete-product]').forEach((button) => {
            button.addEventListener('click', () => {
                document.querySelector('.sidecart__loader').classList.remove('hidden');
                const container = button.closest('.product-cart__container');
                const variant_id = container.getAttribute('data-variant-id');
                const bundleId = container.getAttribute('data-bundle-id');
                if (bundleId) {
                    this.removeBundleItems(bundleId);
                } else {
                    this.removeQty(variant_id);
                }
            });
        });

        const messageAddBtn = this.querySelector('.sidecart-message__content .product-cart__add');
        if (messageAddBtn) messageAddBtn.addEventListener('click', this.addMessage.bind(this));

        const closeMessageBtn = this.querySelector('.sidecart-message [data-close-message]');
        if (closeMessageBtn) {
            closeMessageBtn.addEventListener('click', () => {
                document.querySelector('.sidecart-message').classList.remove('active');
                let inputMessage = this.querySelector('.sidecart-message__message .custom-input');
                let inputEmbalage = this.querySelector('.sidecart-message__embalage .custom-input');

                if (!inputMessage.checked && !inputEmbalage.checked) {
                    this.querySelector('.sidecart-footer__embalage .custom-input').classList.remove('active');
                }
            });
        }

        this.buttonsQty.forEach((button) => {
            const is_pp = button.closest('.sidecart-block-item--pp') ? true : false;
            button.addEventListener('click', (event) => handleButtonClick(button, is_pp));
        });

        this.toggleOpenCartButtons.forEach((button) => {
            button.addEventListener('click', this.closeCart.bind(this));
        });

        // Regular upsell add-to-cart (NOT free modals — those are handled by delegation)
        this.querySelectorAll('.product-cart__upsels [data-add-to-cart]').forEach((button) => {
            if (button.closest('.sidecart-free')) return;
            button.addEventListener('click', () => {
                this.quickAddToCart(button.getAttribute('data-variant-id'), 1, false);
            });
        });

        // Free products: single delegated handler for modals + cards
        this.addEventListener('click', (e) => this._onFreeProductClick(e));

        // Only run progress bar + free products on initial load (not during renderCart)
        if (!SideCart._rendering) {
            this.updateProgressBar();
            this.handleFreeProducts();
        }

        document.addEventListener('DOMContentLoaded', () => {
            this.updateMobilePrice();
        });

        document.querySelectorAll('.product-cart__container [data-pack-product-back]').forEach((button) => {
            button.addEventListener('click', () => {
                const related_id = button.getAttribute('data-related-variant-id');
                const variant_id = button.closest('.product-cart__container').getAttribute('data-current-key');
                let quantity = parseInt(button.closest('.product-cart__container').querySelector('.sidecart__input').value);
                this.quickAddToCartUnCheck(variant_id, quantity, false, related_id);
            });
        });

        document.querySelectorAll('.product-cart__container [data-pack-product]').forEach((button) => {
            button.addEventListener('click', () => {
                const related_id = button.getAttribute('data-related-variant-id');
                const variant_id = button.closest('.product-cart__container').getAttribute('data-current-key');
                let quantity = parseInt(button.closest('.product-cart__container').querySelector('.sidecart__input').value);
                this.quickAddToCartCheck(variant_id, quantity, false, related_id);
            });
        });
    }

    init() {
        const embalageBtn = this.querySelector('.sidecart-footer__embalage');
        if (embalageBtn) embalageBtn.addEventListener('click', this.checkEmbalage.bind(this));
    }

    // ─── Free products: delegated click handler ───────────────────────
    _onFreeProductClick(e) {
        // "Changer" button on free card → open the corresponding modal
        const changeBtn = e.target.closest('[data-change-free-step]');
        if (changeBtn) {
            const step = changeBtn.getAttribute('data-change-free-step');
            const modal = document.querySelector(`[data-free-step="${step}"]`);
            if (modal) modal.classList.add('active');
            return;
        }

        // Close button inside a free modal
        if (e.target.closest('[data-close-free]')) {
            const modal = e.target.closest('.sidecart-free');
            if (modal) modal.classList.remove('active');
            return;
        }

        // "Ajouter" button inside a free modal
        const addBtn = e.target.closest('[data-add-to-cart]');
        if (addBtn) {
            const freeModal = addBtn.closest('.sidecart-free');
            if (!freeModal) return;
            freeModal.classList.remove('active');
            const step = freeModal.getAttribute('data-free-step');
            if (step) freeStepsClaimed.add(step);

            // Update the free card content from the modal variant data
            const modalItem = addBtn.closest('.product-cart');
            const card = document.querySelector(`[data-free-card="${step}"]`);
            if (card && modalItem) {
                const variantImg = modalItem.querySelector('.product-cart__image img');
                const variantTitle = modalItem.querySelector('.product-cart__title');
                const variantPrice = modalItem.querySelector('.product-cart__price--old');
                const cardImg = card.querySelector('.sidecart-free-card__image img');
                if (cardImg && variantImg) {
                    cardImg.src = variantImg.src;
                    if (variantImg.srcset) cardImg.srcset = variantImg.srcset;
                }
                const cardTitle = card.querySelector('.sidecart-free-card__title');
                if (cardTitle && variantTitle) cardTitle.textContent = variantTitle.textContent.trim();
                const cardPrice = card.querySelector('.sidecart-free-card__price s');
                if (cardPrice && variantPrice) cardPrice.textContent = variantPrice.textContent.trim();
                card.style.display = '';
            }

            const productId = freeModal.getAttribute('data-free-product-id');
            this.addFreeProduct(addBtn.getAttribute('data-variant-id'), productId, step);
        }
    }

    // ─── Free products: swap logic (remove old variant, add new) ─────
    async addFreeProduct(newVariantId, productId, step) {
        document.querySelector('.sidecart__loader').classList.remove('hidden');

        // Remove any existing variant of the same free product
        if (productId) {
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();
            const existing = cart.items.find(item => item.product_id === parseInt(productId));
            if (existing) {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: existing.key, quantity: 0 })
                });
            }
        }

        // Add new variant with _free_step property so Liquid can identify it
        const itemData = { id: parseInt(newVariantId), quantity: 1 };
        if (step) {
            itemData.properties = { '_free_step': step };
        }

        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(itemData)
        });

        this.renderCart();
    }

    // ─── Free products: card + modal visibility + auto-remove ────────
    async handleFreeProducts() {
        const container = document.querySelector('.sidecart__container');
        if (!container) return;

        // Calculate step reached directly (don't rely on CSS classes which may be delayed)
        const totalQuantity = parseInt(document.querySelector('[data-tablette-count]')?.dataset.tabletteCount || '0');
        const totalPrice = parseInt(document.querySelector('side-cart .sidecart__progress[data-cart-count]')?.dataset.cartCount || '0');
        const step1El = document.querySelector('side-cart .product-form__progress--bar-item-1[data-reduction-step]');
        const step2El = document.querySelector('side-cart .product-form__progress--bar-item-2[data-reduction-step]');
        const step3El = document.querySelector('side-cart .product-form__progress--bar-item-3[data-reduction-step]');
        const step1Value = step1El ? parseInt(step1El.dataset.reductionStep) : 0;
        const step2Value = step2El ? parseInt(step2El.dataset.reductionStep) : 0;
        const step3Value = step3El ? parseInt(step3El.dataset.reductionStep) : 0;

        const stepReached = [
            totalQuantity >= step1Value,
            totalPrice >= (step2Value * 100),
            totalQuantity >= step3Value
        ];

        // Sync freeStepsClaimed from server data
        [1, 2, 3].forEach((i) => {
            if (container.hasAttribute(`data-free-${i}-in-cart`)) {
                freeStepsClaimed.add(String(i));
            }
        });

        // Auto-remove free products when step is no longer reached
        let needsRerender = false;
        for (const i of [1, 2, 3]) {
            const inCart = container.hasAttribute(`data-free-${i}-in-cart`);
            if (inCart && !stepReached[i - 1]) {
                const modal = document.querySelector(`[data-free-step="${i}"]`);
                const productId = modal ? modal.getAttribute('data-free-product-id') : null;
                if (productId) {
                    const cartResponse = await fetch('/cart.js');
                    const cart = await cartResponse.json();
                    const existing = cart.items.find(item => item.product_id === parseInt(productId));
                    if (existing) {
                        await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: existing.key, quantity: 0 })
                        });
                        needsRerender = true;
                    }
                }
                freeStepsClaimed.delete(String(i));
            }
        }

        if (needsRerender) {
            this.renderCart();
            return;
        }

        // Auto-open modals for newly reached, unclaimed steps
        [1, 2, 3].forEach((i) => {
            if (!stepReached[i - 1]) return;
            if (freeStepsClaimed.has(String(i))) return;
            if (container.hasAttribute(`data-free-${i}-in-cart`)) return;
            const modal = document.querySelector(`[data-free-step="${i}"]`);
            if (!modal || !modal.querySelector('.product-cart__upsels')) return;
            modal.classList.add('active');
        });

        // Show/hide free product cards
        [1, 2, 3].forEach((i) => {
            const card = document.querySelector(`[data-free-card="${i}"]`);
            if (!card) return;
            const inCart = container.hasAttribute(`data-free-${i}-in-cart`);
            const claimed = freeStepsClaimed.has(String(i));
            card.style.display = (inCart || (stepReached[i - 1] && claimed)) ? '' : 'none';
        });

        // Show/hide the title + border
        const freeCardsContainer = document.querySelector('[data-free-cards]');
        if (freeCardsContainer) {
            const hasVisibleCard = freeCardsContainer.querySelector(
                '[data-free-card]:not([style*="display:none"]):not([style*="display: none"])'
            );
            const title = freeCardsContainer.querySelector('.sidecart-free-cards__title');
            if (title) title.style.display = hasVisibleCard ? '' : 'none';
            freeCardsContainer.classList.toggle('sidecart-free-cards--visible', !!hasVisibleCard);
        }
    }

    async checkEmbalage(event) {
        if (event.currentTarget.querySelector('.custom-input').classList.contains('active')) {
            event.currentTarget.querySelector('.custom-input').classList.remove('active');
            this.removeMessage();
        } else {
            event.currentTarget.querySelector('.custom-input').classList.add('active');
            this.querySelector('.sidecart-message').classList.add('active');
        }
    }

    async addMessage() {
        document.querySelector('.sidecart__loader').classList.remove('hidden');
        let hasMessage = this.querySelector('.sidecart-message__message .custom-input').checked;
        let hasEmbalage = this.querySelector('.sidecart-message__embalage .custom-input').checked;

        const attributes = {};
        if (hasMessage) {
            attributes['Gift Message'] = this.querySelector('.sidecart-message__message textarea').value;
        }
        if (hasEmbalage) {
            attributes['Emballage Cadeau'] = '✓';
        }

        if (hasMessage || hasEmbalage) {
            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes }),
            });
        }

        if (hasEmbalage) {
            let id = this.querySelector('.sidecart-message__content .product-cart__add').getAttribute('data-variant-id');
            await fetch(`/cart/add.js?quantity=1&id=${id}`);
        }

        this.renderCart();
    }

    async removeMessage() {
        document.querySelector('.sidecart__loader').classList.remove('hidden');
        let id = this.querySelector('.sidecart-message__content .product-cart__add').getAttribute('data-variant-id');

        await Promise.all([
            fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    attributes: { 'Emballage Cadeau': '', 'Gift Message': '' }
                }),
            }),
            fetch(`/cart/change.js?quantity=0&id=${id}`),
        ]);

        this.querySelector('.sidecart-message').classList.remove('active');
        this.renderCart();
    }

    updateProgressBar() {
        const tabletteEl = document.querySelector('[data-tablette-count]');
        const priceEl = document.querySelector('side-cart .sidecart__progress[data-cart-count]');
        if (!tabletteEl || !priceEl) return;

        const totalQuantity = parseInt(tabletteEl.dataset.tabletteCount);
        const totalPrice = parseInt(priceEl.dataset.cartCount);

        const step1 = document.querySelector('side-cart .product-form__progress--bar-item-1[data-reduction-step]');
        const step2 = document.querySelector('side-cart .product-form__progress--bar-item-2[data-reduction-step]');
        const step3 = document.querySelector('side-cart .product-form__progress--bar-item-3[data-reduction-step]');
        if (!step1 || !step2 || !step3) return;

        const fill1 = step1.querySelector('.progress__fill .fill__content');
        const fill2 = step2.querySelector('.progress__fill .fill__content');
        const fill3 = step3.querySelector('.progress__fill .fill__content');
        if (!fill1 || !fill2 || !fill3) return;

        const step1Value = parseInt(step1.dataset.reductionStep);
        const step2Value = parseInt(step2.dataset.reductionStep);
        const step3Value = parseInt(step3.dataset.reductionStep);

        // Compute target values without applying yet
        let fill1Target = '0%', fill2Target = '0%', fill3Target = '0%';
        let step1Active = false, step2Active = false, step3Active = false;

        // Step 1 (quantity-based)
        if (totalQuantity <= step1Value) {
            let multiply = 100 / step1Value;
            fill1Target = `${multiply * totalQuantity}%`;
            step1Active = totalQuantity == step1Value;
        }
        if (totalQuantity > step1Value) {
            step1Active = true;
            fill1Target = '100%';
        }

        // Step 2 (price-based, starts after step1)
        if (totalPrice >= (step1Value * 100)) {
            let currentAmmout = totalPrice - (step1Value * 100);
            let priceRange = (step2Value * 100) - (step1Value * 100);
            let multiply = priceRange > 0 ? (100 / priceRange) : 100;
            fill2Target = `${multiply * currentAmmout}%`;
            if (totalPrice >= (step2Value * 100)) {
                step2Active = true;
                fill2Target = '100%';
            }
        }

        // Step 3 (quantity-based, starts after step2)
        let price_quantity = step2Value / 10;
        if (totalQuantity == parseInt(price_quantity) || totalQuantity >= parseInt(price_quantity) && totalQuantity <= step3Value) {
            let multiply = 100 / (step3Value - Number(price_quantity));
            fill3Target = `${multiply * (totalQuantity - Number(price_quantity))}%`;
            if (totalQuantity >= step3Value) {
                step3Active = true;
                fill3Target = '100%';
            }
        }
        if (totalQuantity >= step3Value) {
            step3Active = true;
            fill3Target = '100%';
        }

        // Restore previous fill values immediately (no transition flash from 0)
        const prev = SideCart._prevProgress || {};
        if (prev.fill1 !== undefined) {
            fill1.style.transition = 'none';
            fill2.style.transition = 'none';
            fill3.style.transition = 'none';
            fill1.style.width = prev.fill1;
            fill2.style.width = prev.fill2;
            fill3.style.width = prev.fill3;
            if (prev.step1Active) step1.classList.add('active'); else step1.classList.remove('active');
            if (prev.step2Active) step2.classList.add('active'); else step2.classList.remove('active');
            if (prev.step3Active) step3.classList.add('active'); else step3.classList.remove('active');
            // Force reflow before re-enabling transitions
            fill1.offsetHeight;
            fill1.style.transition = '';
            fill2.style.transition = '';
            fill3.style.transition = '';
        }

        // Save current targets for next render
        SideCart._prevProgress = { fill1: fill1Target, fill2: fill2Target, fill3: fill3Target, step1Active, step2Active, step3Active };

        // Check if anything actually changed
        const changed1 = prev.fill1 !== fill1Target || prev.step1Active !== step1Active;
        const changed2 = prev.fill2 !== fill2Target || prev.step2Active !== step2Active;
        const changed3 = prev.fill3 !== fill3Target || prev.step3Active !== step3Active;

        // Apply with sequential delays only on bars that change
        const DELAY = 350;

        // Step 1: immediate
        fill1.style.width = fill1Target;
        if (step1Active) { step1.classList.add('active'); } else { step1.classList.remove('active'); }

        // Step 2: delayed only if step 1 changed and is full
        const delay2 = (changed1 && step1Active) ? DELAY : 0;
        setTimeout(() => {
            fill2.style.width = fill2Target;
            if (step2Active) { step2.classList.add('active'); } else { step2.classList.remove('active'); }
        }, delay2);

        // Step 3: delayed only if earlier bars changed
        const delay3 = delay2 + ((changed2 && step2Active) ? DELAY : 0);
        setTimeout(() => {
            fill3.style.width = fill3Target;
            if (step3Active) { step3.classList.add('active'); } else { step3.classList.remove('active'); }
        }, delay3);
    }

    openCart() {
        document.querySelector('#section-sidecart').classList.add('active');
        document.body.style.top = `-${window.scrollY}px`;
        document.querySelector('body').classList.add('overflow-hidden');
    }

    closeCart() {
        document.querySelector('#section-sidecart').classList.remove('active');
        const scrollY = document.body.style.top;
        document.querySelector('body').classList.remove('overflow-hidden');
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    async updateQty(id, qty) {
        const response = await fetch(`/cart/change.js?quantity=${qty}&id=${id}`);
        const data = await response.json();
        if (data.status === 422 || data.message) {
            this.showStockToast(data.description || data.message);
        }
        await this.cleanupFreeProducts();
        this.renderCart();
    }

    async removeQty(id) {
        const response = await fetch(`/cart/change.js?quantity=0&id=${id}`);
        const data = await response.json();
        await this.cleanupFreeProducts();
        this.renderCart();
    }

    async removeBundleItems(bundleId) {
        const containers = this.querySelectorAll(`[data-bundle-id="${bundleId}"]`);
        const keys = [];
        containers.forEach(c => {
            const key = c.getAttribute('data-current-key');
            if (key) keys.push(key);
        });
        for (const key of keys) {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: key, quantity: 0 })
            });
        }
        await this.cleanupFreeProducts();
        this.renderCart();
    }

    async cleanupFreeProducts() {
        const step1El = document.querySelector('side-cart .product-form__progress--bar-item-1[data-reduction-step]');
        const step2El = document.querySelector('side-cart .product-form__progress--bar-item-2[data-reduction-step]');
        const step3El = document.querySelector('side-cart .product-form__progress--bar-item-3[data-reduction-step]');
        if (!step1El && !step2El && !step3El) return false;

        // Fetch fresh section HTML to get accurate tablette count and cart total
        const [cartResponse, sectionResponse] = await Promise.all([
            fetch('/cart.js'),
            fetch(`${window.Shopify.routes.root}?section_id=sidecart`)
        ]);
        const cart = await cartResponse.json();
        const sectionHtml = await sectionResponse.text();
        const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');

        const freshTabletteCount = parseInt(doc.querySelector('[data-tablette-count]')?.dataset.tabletteCount || '0');
        const freshTotalPrice = parseInt(doc.querySelector('side-cart .sidecart__progress[data-cart-count]')?.dataset.cartCount || '0');

        const step1Value = step1El ? parseInt(step1El.dataset.reductionStep) : 0;
        const step2Value = step2El ? parseInt(step2El.dataset.reductionStep) : 0;
        const step3Value = step3El ? parseInt(step3El.dataset.reductionStep) : 0;

        const stepReached = [
            freshTabletteCount >= step1Value,
            freshTotalPrice >= (step2Value * 100),
            freshTabletteCount >= step3Value
        ];

        const freshContainer = doc.querySelector('.sidecart__container');
        let removedAny = false;

        for (const i of [1, 2, 3]) {
            const inCart = freshContainer?.hasAttribute(`data-free-${i}-in-cart`);
            if (inCart && !stepReached[i - 1]) {
                const modal = document.querySelector(`[data-free-step="${i}"]`);
                const productId = modal ? modal.getAttribute('data-free-product-id') : null;
                if (productId) {
                    const existing = cart.items.find(item => item.product_id === parseInt(productId));
                    if (existing) {
                        await fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: existing.key, quantity: 0 })
                        });
                        removedAny = true;
                    }
                }
                freeStepsClaimed.delete(String(i));
            }
        }

        return removedAny;
    }

    async quickAddToCart(id, quantity = 1, open = true) {
        document.querySelector('.sidecart__loader').classList.remove('hidden');
        const response = await fetch(`/cart/add.js?quantity=${quantity}&id=${id}`);
        const data = await response.json();
        if (data.status === 422 || data.message) {
            this.showStockToast(data.description || data.message);
        }
        await this.cleanupFreeProducts();
        this.renderCart(open);
    }

    async quickAddToCartUnCheck(id, quantity = 1, open = true, related) {
        document.querySelector('.sidecart__loader').classList.remove('hidden');
        const response = await fetch(`/cart/change.js?quantity=0&id=${id}`);
        const data = await response.json();
        const response2 = await fetch(`/cart/add.js?quantity=${quantity}&id=${related}`);
        const data2 = await response2.json();
        await this.cleanupFreeProducts();
        this.renderCart(open);
    }

    async quickAddToCartCheck(id, quantity = 1, open = true, related) {
        document.querySelector('.sidecart__loader').classList.remove('hidden');

        const response = await fetch(`/cart/change.js?quantity=${quantity - 1}&id=${id}`);
        const data = await response.json();
        let related_id = document.querySelector(`[data-current-key="${id}"]`).getAttribute('data-variant-id');
        const response2 = await fetch(`/cart/add.js?quantity=1&id=${related}`);
        const data2 = await response2.json();
        await this.cleanupFreeProducts();
        this.renderCart(open);
    }

    async updateMultipleQty(ids, qty) {
        const updates = ids.reduce((acc, id) => {
            acc[id] = qty;
            return acc;
        }, {});

        const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ updates }),
        });

        const data = await response.json();
        await this.cleanupFreeProducts();
        this.renderCart();
    }

    showLoader() {
        this.loader.classList.remove('hidden');
    }

    renderCart(open = false) {
        // Save modals AND free cards before re-render
        // (section rendering API may not resolve section.settings product objects,
        //  so these elements would be empty/missing in the fresh HTML)
        const savedModals = [];
        document.querySelectorAll('.sidecart-free[data-free-step]').forEach((modal) => {
            savedModals.push(modal.outerHTML);
        });
        const savedFreeCards = document.querySelector('[data-free-cards]')?.outerHTML || '';

        SideCart._rendering = true;

        const url = `${window.Shopify.routes.root}?section_id=sidecart`;
        fetch(url)
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newCart = doc.querySelector('#section-sidecart');

                document.querySelector('#section-sidecart').innerHTML = newCart.innerHTML;

                // Re-inject saved modals
                if (savedModals.length) {
                    const newModals = document.querySelectorAll('.sidecart-free[data-free-step]');
                    newModals.forEach((emptyModal, index) => {
                        if (savedModals[index]) {
                            emptyModal.outerHTML = savedModals[index];
                        }
                    });
                }

                // Re-inject saved free cards
                if (savedFreeCards) {
                    const newCards = document.querySelector('[data-free-cards]');
                    if (newCards) {
                        // Server rendered the container → replace with saved version
                        newCards.outerHTML = savedFreeCards;
                    } else {
                        // Server didn't render the container → inject it at the end of the products list
                        const productsList = document.querySelector('.sidecart-products-os__products');
                        if (productsList) {
                            productsList.insertAdjacentHTML('beforeend', savedFreeCards);
                        }
                    }
                }

                SideCart._rendering = false;

                // Update cart count in header
                const newCount = doc.querySelector('[data-items-count]');
                if (newCount) {
                    const count = parseInt(newCount.dataset.itemsCount);
                    document.querySelectorAll('.header__cart-count').forEach((el) => {
                        el.textContent = count;
                        el.style.display = count > 0 ? '' : 'none';
                    });
                }

                if (document.querySelector('builder-pack')) {
                    document.querySelector('builder-pack').updatePrice();
                }

                const newSideCart = document.querySelector('side-cart');
                if (newSideCart) {
                    newSideCart.updateProgressBar();
                    newSideCart.handleFreeProducts();
                    newSideCart.updateCardsProducts();
                }

                if (open) {
                    const currentSideCart = document.querySelector('side-cart');
                    if (currentSideCart) {
                        currentSideCart.openCart();
                    } else {
                        this.openCart();
                    }
                }
            })
            .catch(() => {
                SideCart._rendering = false;
                const loader = document.querySelector('.sidecart__loader');
                if (loader) loader.classList.add('hidden');
            });
    }

    showStockToast(msg) {
        const toast = document.querySelector('[data-stock-toast]');
        if (!toast) return;
        if (msg) toast.querySelector('p').textContent = msg;
        toast.classList.add('active');
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(() => toast.classList.remove('active'), 3000);
    }

    updateCardsProducts() {
        const product_cards = document.querySelectorAll('.product-card:not(.product-card--builder)');
        const add_to_cart_btns = document.querySelectorAll('.add-to-cart.button');
        const totalPriceEl = document.querySelector('[data-total-price]');
        const cartTotalPrice = totalPriceEl ? parseInt(totalPriceEl.dataset.totalPrice) : 0;

        const updateDiscountSpans = (container) => {
            const priceSpans = container.querySelectorAll('[data-start-discount]');
            let matchingSpan = null;
            priceSpans.forEach((span) => {
                if (parseInt(span.dataset.startDiscount) <= cartTotalPrice) {
                    matchingSpan = span;
                }
                span.classList.add('hidden');
            });
            if (matchingSpan) {
                matchingSpan.classList.remove('hidden');
            }
        };

        product_cards.forEach((card) => {
            if (!card.classList.contains('product-card--builder')) {
                const variant_id = card.getAttribute('data-variant-id');
                const input = card.querySelector('input');

                const cart_item = document.querySelector('.sidecart-block-item[data-variant-id="' + variant_id + '"]');

                if (cart_item) {
                    const qty = parseInt(cart_item.querySelector('.sidecart__input-value').innerHTML);
                    input.value = qty;
                    card.querySelector('span').innerHTML = qty;
                    card.classList.add('has-quantity');
                } else {
                    input.value = 0;
                    card.querySelector('span').innerHTML = 1;
                    card.querySelector('input').value = 0;
                    card.classList.remove('has-quantity');
                }
            }

            updateDiscountSpans(card);
        });

        add_to_cart_btns.forEach((btn) => {
            updateDiscountSpans(btn);
        });

        this.updateMobilePrice();
    }

    updateMobilePrice() {
        const product_cards = document.querySelectorAll('.product-card:not(.product-card--builder)');

        product_cards.forEach(function (card) {
            var priceDesktop = card.querySelector('.show-desktop .card-price:not(.hidden)');
            var priceMobile = card.querySelector('.show-mobile');
            if (!priceDesktop || !priceMobile) return;

            var compareAtPriceDesktop = card.querySelector('.show-desktop .card-price:not(.hidden) s');

            if (compareAtPriceDesktop) {
                var compareAtPrice = compareAtPriceDesktop.textContent.trim();
                var priceParts = priceDesktop.textContent.trim().split('€');
                var newPrice = priceParts.length >= 3 ? '€' + priceParts[2] : priceDesktop.textContent.trim();

                if (compareAtPrice !== newPrice) {
                    priceMobile.innerHTML = `<s>${compareAtPrice}</s> ${newPrice}`;
                } else {
                    priceMobile.textContent = newPrice;
                }
            } else {
                priceMobile.textContent = priceDesktop.textContent.trim();
            }

            priceMobile.classList.remove('hidden');
        });
    }
}

customElements.define('side-cart', SideCart);

class ShippingCalculator extends HTMLElement {
    constructor() {
        super();
        this.shippingDate = this.querySelector('[data-shipping-date]');

        const today = new Date();
        const daysToAdd = 2;
        const deliveryDate = new Date(today);
        deliveryDate.setDate(deliveryDate.getDate() + daysToAdd);

        if (deliveryDate.getDay() === 6) {
            deliveryDate.setDate(deliveryDate.getDate() + 2);
        } else if (deliveryDate.getDay() === 0) {
            deliveryDate.setDate(deliveryDate.getDate() + 1);
        }

        const options = { weekday: 'short', day: 'numeric', month: 'short' };
        this.shippingDate.innerHTML = `Recevez le <b>${deliveryDate.toLocaleDateString('fr-FR', options)}</b>`;
    }
}

customElements.define('shipping-calculator', ShippingCalculator);

class SideCartUpsells extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const swiper = new Swiper(this.querySelector('.swiper'), {
            slidesPerView: 'auto',

            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            on: {
                slideChangeTransitionStart: () => {
                    isSwiperActive = true;
                },
                slideChangeTransitionEnd: () => {
                    isSwiperActive = false;
                },
            },
        });
    }
}

customElements.define('side-cart-upsells', SideCartUpsells);
